import ROUTING_STATE_SHAPE from 'rlink-router/ROUTING_STATE_SHAPE';

export default function getOpenModals (routing) {
  return ROUTING_STATE_SHAPE.getAt(routing, ['modals']);
}



// WEBPACK FOOTER //
// ./lib/rlink-router/getOpenModals.js